import React, { useEffect, useRef, useState } from "react";
import QrScanner from "qr-scanner";

const QRScanner = ({ addQrScan }) => {
    const [qrDataList, setQrDataList] = useState([]);
    const [lastScanned, setLastScanned] = useState(null);
    const videoRef = useRef(null);
    const scannerRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (videoRef.current && containerRef.current) {
            // Create overlay element
            const overlay = document.createElement('div');
            overlay.className = 'scan-region-highlight';
            containerRef.current.appendChild(overlay);

            scannerRef.current = new QrScanner(
                videoRef.current,
                (result) => {
                    if (result?.data && result.data !== lastScanned) {
                        if (!qrDataList.includes(result.data)) {
                            setQrDataList((prevList) => [...prevList, result.data]);
                            
                            if (typeof addQrScan === 'function') {
                                addQrScan(result.data);
                            } else {
                                console.error("addQrScan is not a function:", addQrScan);
                            }
                        }
                        
                        setLastScanned(result.data);
                        // Avoid re-scanning the same code immediately
                        setTimeout(() => setLastScanned(null), 3000);
                    }
                },
                {
                    preferredCamera: 'environment',
                    highlightScanRegion: true,
                    highlightCodeOutline: true,
                    overlay: overlay
                }
            );

            scannerRef.current.start().catch((error) => {
                window.$alertError("QR Scan Error: " + error);
                console.error("QR Scan Error:", error);
            });
        }

        return () => {
            if (scannerRef.current) {
                scannerRef.current.stop();
            }
            // Clean up overlay element
            if (containerRef.current) {
                const overlay = containerRef.current.querySelector('.scan-region-highlight');
                if (overlay) {
                    overlay.remove();
                }
            }
        };
    }, []);

    return (
        <div ref={containerRef} style={{ width: "100%", maxWidth: "640px", maxHeight: '35vh', position: 'relative', margin: "0 auto", overflow: 'hidden' }}>
            <div style={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center", height: '100%' }}>
                <div style={{ position: "relative", width: "100%", paddingTop: "100%", overflow: "hidden" }}>
                    <video ref={videoRef} style={{ position: "absolute", top: "0", left: "0", transform: "translate(-50%, -50%)", width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                </div>
                <style>
                    {`
                        .scan-region-highlight {
                            position: absolute;
                            inset: 0;
                            margin: auto;
                            width: 70%;
                            aspect-ratio: 1;
                            border: 2px solid #fff;
                            border-radius: 8px;
                            pointer-events: none;
                            z-index: 1;
                            top: 0 !important;
                            left: 0 !important;
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default QRScanner;